import React, { useEffect, useState } from 'react';
import Spinner from '../ogComponent/spinner';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import Table from '../ogComponent/table';
import "./attendence.css";

export default function SingleDayFullPunch() {
  const { userId } = useParams();
  const [product, setProduct] = useState([]);
  const [employee, setEmployee] = useState({});
  const [loading, setLoading] = useState(true);
  const [selectDate, setSelectDate] = useState(dayjs());
  const [workedHours, setWorkedHours] = useState('');
  const [shiftWorkingHours, setShiftWorkingHours] = useState('');
  const [actualWorkedHours, setActualWorkedHours] = useState('');
  const [expectedCheckOut, setExpectedCheckOut] = useState('');
  const [currentPage, setCurrentPage] = useState(1);

  const header = [
    { name: 'Si No', label: '#', active: true },
    { name: 'Date', label: 'Punch Date', active: true },
    { name: 'Day', label: 'Day', active: true },
    { name: 'type', label: 'Direction', active: true },
    { name: 'time', label: 'Timestamp', active: true },
  ];

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  useEffect(() => {
    const token = localStorage.getItem('accessToken');

    const fetchAttendanceData = async () => {
      try {
        setLoading(true);
        const formattedDate = selectDate.format('YYYY-MM-DD');

        const [attendanceResponse, workedHoursResponse] = await Promise.all([
          axios.get(`${process.env.REACT_APP_API}/api/attendance/single-attendance/`, {
            params: { punch_date: formattedDate, employee__id: userId },
            headers: { Authorization: `Bearer ${token}` },
          }),
          axios.get(`${process.env.REACT_APP_API}/api/attendance/employee-worked-hours/${userId}/`, {
            params: { start_date: formattedDate, end_date: formattedDate },
            headers: { Authorization: `Bearer ${token}` },
          })
        ]);

        const attendanceData = attendanceResponse.data[0];
        const workedHoursData = workedHoursResponse.data;

        if (attendanceData) {
          setEmployee(attendanceData.employee_details);
          const formattedPunchData = attendanceData.punch_details.map((punch, index) => ({
            'Si No': index + 1,
            Date: dayjs(attendanceData.punch_date).format('DD MMM YYYY'),
            Day: attendanceData.day,
            type: (
              <span className={`status-pill ${punch.punch_direction?.toUpperCase() === 'IN' || punch.punch_direction?.toLowerCase() === 'clock-in' ? 'status-active-pill' : 'status-inactive-pill'}`}>
                <span className="status-spot"></span>
                {punch.punch_direction}
              </span>
            ),
            time: <span className="fw-bold text-main">{punch.punch_time}</span>,
          }));
          setProduct(formattedPunchData);
        } else {
          setProduct([]);
        }

        if (workedHoursData.worked_hours && workedHoursData.worked_hours.length > 0) {
          setWorkedHours(workedHoursData.worked_hours[0].worked_hours);
          setActualWorkedHours(workedHoursData.worked_hours[0].actual_worked_hours);
        } else {
          setWorkedHours('00:00:00');
          setActualWorkedHours('00:00:00');
        }

        setShiftWorkingHours(workedHoursData.shift_working_hours);
        setExpectedCheckOut(workedHoursData.expected_check_out);

        setLoading(false);
      } catch (error) {
        console.error('Error fetching data:', error);
        setLoading(false);
        setProduct([]);
      }
    };

    fetchAttendanceData();
  }, [selectDate, userId]);

  return (
    <div className="AttendanceContainer w-100 h-100 px-4 pt-4 pb-5">
      {/* <div className="attendance-header mb-4">
        <h3 className="m-0">Daily Punch Analysis</h3>
        <p className="text-muted small mb-0">Granular view of all entry and exit timestamps for a specific working day.</p>
      </div> */}

      <div className="attendance-filters">
        <div className="info-text-box">
          <p className="m-0 text-muted small fw-bold uppercase">EMPLOYEE RECORD</p>
          <h5 className="m-0 fw-bold text-main">{employee.Name || 'N/A'}</h5>
          <span className="text-muted small">{employee.Job_position} • {employee.Branch_name}</span>
        </div>

        <div className="date-picker-group">
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Review Date"
              value={selectDate}
              onChange={(newValue) => setSelectDate(newValue)}
              slotProps={{ textField: { size: 'small', sx: { width: 220 } } }}
            />
          </LocalizationProvider>
        </div>
      </div>

      {loading ? (
        <div className="py-5 text-center"><Spinner /></div>
      ) : (
        <div className="attendance-table-wrapper">
          {product.length > 0 ? (
            <>
              <div className="row g-3 mb-4">
                {[
                  { label: 'Total Duration', value: actualWorkedHours, color: 'primary' },
                  { label: 'Calculated Work', value: workedHours, sub: `(Shift: ${shiftWorkingHours})`, color: 'success' },
                  { label: 'Target Exit', value: expectedCheckOut, color: 'info' }
                ].map((stat, i) => (
                  <div key={i} className="col-12 col-md-4">
                    <div className="p-3 rounded-4 border text-center shadow-sm" style={{ backgroundColor: 'var(--bg-color)' }}>
                      <small className="text-muted d-block mb-1 uppercase fw-bold" style={{ fontSize: '10px', letterSpacing: '0.5px' }}>{stat.label}</small>
                      <div className="fw-bold fs-5 text-main">
                        {stat.value} {stat.sub && <small className="fw-normal" style={{ fontSize: '11px' }}>{stat.sub}</small>}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <Table
                header={header}
                product={product}
                onRowClick={() => { }}
                currentPage={currentPage}
                onPageChange={handlePageChange}
              />
            </>
          ) : (
            <div className="empty-attendance py-5">
              <img src="/assets/file.png" className="empty-img" alt="No data" />
              <p className="fw-semibold text-muted">No punch records or leave data found for this date.</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
}